import Blog_50_container from "./container/Blog_50_container";
export default Blog_50_container;
